export const StaySmallSmallHeroText = () => {
  return (
    <div className="text-start my-8">
      <h1 className="text-[25px] font-bold  font-duplet">
        Find a place away from home
      </h1>
      <p className="font-normal text-sm">
        Bespoke accommodation with a real taste of luxury or a minimalist space
        at a pocket friendly rate
      </p>
    </div>
  );
};
